"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9599],{

/***/ 21193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CruiseContentTitle; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96749);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88433);
/* harmony import */ var main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36716);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);






var CruiseContentTitle = function CruiseContentTitle(props) {
  var children = props.children;
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("h2", {
    css: titleStyle,
    children: children
  });
};
var titleStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("font-size:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontSize.title */ .JB.title, ";line-height:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .lineHeight.title */ .Nv.title, ";font-weight:", main_javascripts_styles_base_typographyStyle__WEBPACK_IMPORTED_MODULE_3__/* .fontWeight.medium */ .Ue.medium, ";padding:", main_javascripts_styles_base_spaceStyle__WEBPACK_IMPORTED_MODULE_1__/* .space.atom2x */ .D.atom2x, " 0;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_2__/* .moreThanBreakpoint */ .h6)("desktop"), "{font-size:1.75rem;line-height:1.4;}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 58451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ CruiseRouteList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/constants/CruiseRouteTypes.ts
var CruiseRouteTypes = {
  port: "port",
  sailing: "sailing"
};
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteList.tsx












var emptyTime = "00:00";
var CruiseRouteList = function CruiseRouteList(props) {
  var cruiseRoutes = props.cruiseRoutes;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var getLastDay = function getLastDay(routes) {
    if ((routes === null || routes === void 0 ? void 0 : routes.length) === 0) {
      return 0;
    }

    var lastRoute = routes[routes.length - 1];
    return lastRoute.day;
  };

  var lastDay = getLastDay(cruiseRoutes);

  var renderRouteData = function renderRouteData(route) {
    // sailingの場合終日航海と見なしている
    if (route.routeType === CruiseRouteTypes.sailing) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: routeTitleStyle,
          children: route.title
        })
      }, route.id);
    } // 滞在箇所が基準になっていると思われるため
    // arrivalTimeを先に表示


    var timeDisplay = function timeDisplay() {
      if (route.day === 1 && route.arrivalTime === emptyTime) {
        return t("cruise.departs", {
          time: route.departureTime
        });
      } else if (route.day === lastDay && route.departureTime === emptyTime) {
        return t("cruise.arrives", {
          time: route.arrivalTime
        });
      } else {
        return "".concat(route.arrivalTime, " - ").concat(route.departureTime);
      }
    };

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: routeTitleStyle,
        children: route.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: routeTimeStyle,
        children: timeDisplay()
      })]
    }, route.id);
  };

  var groupByDay = function groupByDay(routes) {
    if ((routes === null || routes === void 0 ? void 0 : routes.length) === 0) {
      return {};
    }

    return routes.reduce(function (acc, route) {
      if (!acc[route.day]) {
        acc[route.day] = [];
      }

      acc[route.day].push(route);
      return acc;
    }, {});
  };

  var groupedRoutes = groupByDay(cruiseRoutes);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    css: routeItemBlockStyle,
    children: Object.entries(groupedRoutes).map(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          day = _ref2[0],
          routes = _ref2[1];

      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: routeItemStyle,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: routeDayStyle,
          children: t("cruise.dayLabel", {
            day: day
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: routeDataListStyle,
          children: routes.map(function (route) {
            return renderRouteData(route);
          })
        })]
      }, day);
    })
  });
};
var routeItemBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding-top:", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var routeItemStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:grid;grid-template-columns:4rem 1fr;align-items:flex-start;gap:", spaceStyle/* space.atom2_5x */.D.atom2_5x, ";padding-bottom:", spaceStyle/* space.atom3x */.D.atom3x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{gap:", spaceStyle/* space.atom3x */.D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var routeDayStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.caption */.JB.caption, ";line-height:", typographyStyle/* lineHeight.caption2 */.Nv.caption2, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";background-color:", colorStyle/* borderColor.primaryLightColor */.tv.primaryLightColor, ";display:flex;align-items:center;justify-content:center;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";" + ( true ? "" : 0),  true ? "" : 0);
var routeDataListStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("display:grid;grid-template-columns:1fr;gap:", spaceStyle/* space.atom2x */.D.atom2x, ";" + ( true ? "" : 0),  true ? "" : 0);
var routeTitleStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.mediumHeading */.JB.mediumHeading, ";line-height:", typographyStyle/* lineHeight.mediumHeadline2 */.Nv.mediumHeadline2, ";font-weight:", typographyStyle/* fontWeight.medium */.Ue.medium, ";" + ( true ? "" : 0),  true ? "" : 0);
var routeTimeStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("font-size:", typographyStyle/* fontSize.body */.JB.body, ";line-height:", typographyStyle/* lineHeight.body2 */.Nv.body2, ";color:", colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor, ";opacity:0.7;" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 28801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ CruiseRouteListMap; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27812);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70917);
/* harmony import */ var main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25968);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58589);
/* harmony import */ var main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80910);
/* harmony import */ var main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88433);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var CruiseRouteListMap = function CruiseRouteListMap(props) {
  var cruiseRoutes = props.cruiseRoutes;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(1),
      _React$useState2 = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_React$useState, 2),
      scale = _React$useState2[0],
      setScale = _React$useState2[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setScale(window.devicePixelRatio > 1 ? 2 : 1);
  }, []);

  var getMiddlePosition = function getMiddlePosition(prev, next) {
    if (prev && next) {
      var lat1 = Number(prev.lat);
      var lon1_original = Number(prev.lng);
      var lat2 = Number(next.lat);
      var lon2_original = Number(next.lng); // 経度が180度以上離れている場合、一方を±360度シフト

      var lon1 = lon1_original;
      var lon2 = lon2_original;

      if (Math.abs(lon1 - lon2) > 180) {
        if (lon1 > lon2) {
          lon2 += 360;
        } else {
          lon1 += 360;
        }
      }

      var latitude = (lat1 + lat2) / 2;
      var midpointLongitude = (lon1 + lon2) / 2;

      if (midpointLongitude > 180) {
        midpointLongitude -= 360;
      } else if (midpointLongitude <= -180) {
        midpointLongitude += 360;
      }

      return {
        lat: latitude,
        lng: midpointLongitude
      };
    }

    return null;
  };

  var findNearestPosition = function findNearestPosition(routes, currentIndex) {
    var prev = routes.slice(0, currentIndex).reverse().find(function (route) {
      var _route$port, _route$port2;

      return (route === null || route === void 0 ? void 0 : (_route$port = route.port) === null || _route$port === void 0 ? void 0 : _route$port.latitude) && (route === null || route === void 0 ? void 0 : (_route$port2 = route.port) === null || _route$port2 === void 0 ? void 0 : _route$port2.longitude);
    });
    var next = routes.slice(currentIndex + 1).find(function (route) {
      var _route$port3, _route$port4;

      return (route === null || route === void 0 ? void 0 : (_route$port3 = route.port) === null || _route$port3 === void 0 ? void 0 : _route$port3.latitude) && (route === null || route === void 0 ? void 0 : (_route$port4 = route.port) === null || _route$port4 === void 0 ? void 0 : _route$port4.longitude);
    });
    return getMiddlePosition(prev ? {
      lat: Number(prev.port.latitude),
      lng: Number(prev.port.longitude)
    } : null, next ? {
      lat: Number(next.port.latitude),
      lng: Number(next.port.longitude)
    } : null);
  };

  var markerData = function () {
    var positionCountMap = {};
    return cruiseRoutes.map(function (cruiseRoute, index) {
      var position = null;
      var isInvalid = cruiseRoute.routeType === "sailing" || !cruiseRoute.port || !cruiseRoute.port.latitude || !cruiseRoute.port.longitude;

      if (!isInvalid) {
        position = {
          lat: Number(cruiseRoute.port.latitude),
          lng: Number(cruiseRoute.port.longitude)
        };
      } else {
        position = findNearestPosition(cruiseRoutes, index);
      }

      var positionKey = position ? "".concat(position.lat, ",").concat(position.lng) : null;
      var duplicateCount = positionKey ? positionCountMap[positionKey] || 0 : 0;
      if (positionKey) positionCountMap[positionKey] = duplicateCount + 1;
      return {
        day: cruiseRoute.day,
        title: cruiseRoute.title,
        position: position,
        duplicateCount: duplicateCount
      };
    });
  }();

  var coordinates = markerData.filter(function (data) {
    return data.position !== null;
  }).map(function (data) {
    return data.position;
  });
  var filteredMarkerData = markerData.filter(function (data) {
    return data.position !== null;
  }); // 経度を中心（center）に対してシフトする関数

  var shiftLongitude = function shiftLongitude(lon, center) {
    var shifted = lon - center;
    shifted = (shifted + 180) % 360 - 180;
    return shifted;
  };

  var calculateZoom = function calculateZoom(locations) {
    var latitudes = locations.map(function (loc) {
      return loc.lat;
    });
    var longitudes = locations.map(function (loc) {
      return loc.lng;
    });
    var avgLon = longitudes.reduce(function (a, b) {
      return a + b;
    }, 0) / longitudes.length;
    var shiftedLongitudes = longitudes.map(function (lon) {
      return shiftLongitude(lon, avgLon);
    });
    var maxLon = Math.max.apply(Math, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(shiftedLongitudes));
    var minLon = Math.min.apply(Math, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(shiftedLongitudes));
    var maxLat = Math.max.apply(Math, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(latitudes));
    var minLat = Math.min.apply(Math, (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(latitudes));
    var latDiff = maxLat - minLat;
    var lonDiff = maxLon - minLon;
    var maxDiff = Math.max(latDiff * 2, lonDiff);
    if (maxDiff > 200) return 1;
    if (maxDiff > 100) return 2;
    if (maxDiff > 40) return 3;
    if (maxDiff > 15) return 4;
    if (maxDiff > 7) return 5;
    if (maxDiff > 4) return 6;
    if (maxDiff > 2) return 7;
    return 8;
  };

  function calculateCenter(coordinates) {
    var toRad = function toRad(deg) {
      return deg * Math.PI / 180;
    };

    var toDeg = function toDeg(rad) {
      return rad * 180 / Math.PI;
    };

    var x = 0,
        y = 0,
        z = 0;
    coordinates.forEach(function (coord) {
      var lat = toRad(coord.lat);
      var lon = toRad(coord.lng);
      x += Math.cos(lat) * Math.cos(lon);
      y += Math.cos(lat) * Math.sin(lon);
      z += Math.sin(lat);
    });
    var total = coordinates.length;
    x /= total;
    y /= total;
    z /= total;
    var hyp = Math.sqrt(x * x + y * y);
    var centerLat = Math.atan2(z, hyp);
    var centerLon = Math.atan2(y, x);
    return {
      lat: toDeg(centerLat),
      lng: toDeg(centerLon)
    };
  }

  var zoom = calculateZoom(coordinates);
  var center = calculateCenter(coordinates); // Static Maps 用の URL を生成
  // ※サイズは例として600x288(px)（CSSの高さ 18rem ≒ 288px を参考）としています

  var mapWidth = 600;
  var mapHeight = 288;
  var pinColor = main_javascripts_styles_base_colorStyle__WEBPACK_IMPORTED_MODULE_3__/* .accentColor.primaryColor.replace */ .z.primaryColor.replace("#", "0x"); // 各マーカーについて、パラメータ（例：ラベルは day の下1桁）を作成

  var markersParams = filteredMarkerData.map(function (data) {
    return "markers=label:".concat(String(data.day % 10), "|color:").concat(pinColor, "|").concat(data.position.lat, ",").concat(data.position.lng);
  }).join("&"); // ルートのラインを示すパスパラメータ（各座標をパイプ(|)で区切り）

  var validCoordinates = coordinates.filter(function (coord) {
    return coord;
  });
  var pathParam = validCoordinates.length ? "path=weight:3|color:0x000000|".concat(validCoordinates.map(function (coord) {
    return "".concat(coord.lat, ",").concat(coord.lng);
  }).join("|")) : "";
  var staticMapUrl = "https://maps.googleapis.com/maps/api/staticmap?center=".concat(center.lat, ",").concat(center.lng, "&zoom=").concat(zoom, "&size=").concat(mapWidth, "x").concat(mapHeight, "&scale=").concat(scale, "&map_id=ca303613a46cfe5a&").concat(markersParams).concat(pathParam ? "&" + pathParam : "", "&key=").concat(main_javascripts_constants_Constants__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_API_KEY */ .JO);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
    css: blockStyle,
    children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("img", {
      src: staticMapUrl,
      alt: "Cruise Route Map",
      css: mapStyle
    })
  });
};
var blockStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)("width:auto;height:18rem;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_2__/* .borderRadius.normal */ .E.normal, ";overflow:hidden;position:relative;outline:none;", (0,main_javascripts_styles_base_responsiveStyle__WEBPACK_IMPORTED_MODULE_4__/* .moreThanBreakpoint */ .h6)("tablet"), "{height:20rem;}" + ( true ? "" : 0),  true ? "" : 0);
var mapStyle =  true ? {
  name: "4uwt2b",
  styles: "width:100%;height:100%;object-fit:cover"
} : 0;

/***/ }),

/***/ 69599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CruiseRouteListModalDialog; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./main/javascripts/components/modal/ModalDialogWithClose.tsx
var ModalDialogWithClose = __webpack_require__(575);
// EXTERNAL MODULE: ./main/javascripts/components/button/Button.tsx
var Button = __webpack_require__(95284);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseRouteListMap.tsx
var CruiseRouteListMap = __webpack_require__(28801);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/@vis.gl/react-google-maps/dist/index.modern.mjs
var index_modern = __webpack_require__(81323);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/shadowStyle.ts
var shadowStyle = __webpack_require__(78698);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteListMarker.tsx






var CruiseRouteListMarker = function CruiseRouteListMarker(props) {
  var index = props.index,
      position = props.position,
      _props$duplicateCount = props.duplicateCount,
      duplicateCount = _props$duplicateCount === void 0 ? 0 : _props$duplicateCount;
  var left = duplicateCount > 0 ? 1 : 0;
  var markerStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(markerStyle, ";left:", left * 80, "%;" + ( true ? "" : 0),  true ? "" : 0);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* AdvancedMarker */._Q, {
    position: position,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: markerStyles,
      children: index
    })
  });
};
var markerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("position:relative;top:1rem;width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;background-color:", colorStyle/* accentColor.primaryColor */.z.primaryColor, ";color:", colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor, ";border-radius:50%;box-shadow:", shadowStyle/* boxShadow.interface */.W["interface"], ";&:hover{background-color:", colorStyle/* backgroundColor.primaryDarkColor */.Cz.primaryDarkColor, ";}" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./main/javascripts/components/googleMap/Polyline.tsx


var _excluded = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut", "encodedPath"];
// https://github.com/visgl/react-google-maps/blob/main/examples/geometry/src/components/polyline.tsx

/* eslint-disable complexity */



function usePolyline(props) {
  var _useContext;

  var onClick = props.onClick,
      onDrag = props.onDrag,
      onDragStart = props.onDragStart,
      onDragEnd = props.onDragEnd,
      onMouseOver = props.onMouseOver,
      onMouseOut = props.onMouseOut,
      encodedPath = props.encodedPath,
      polylineOptions = (0,objectWithoutProperties/* default */.Z)(props, _excluded); // This is here to avoid triggering the useEffect below when the callbacks change (which happen if the user didn't memoize them)


  var callbacks = (0,react.useRef)({});
  Object.assign(callbacks.current, {
    onClick: onClick,
    onDrag: onDrag,
    onDragStart: onDragStart,
    onDragEnd: onDragEnd,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  });
  var geometryLibrary = (0,index_modern/* useMapsLibrary */.kY)("geometry");
  var polyline = (0,react.useRef)(new google.maps.Polyline()).current; // update PolylineOptions (note the dependencies aren't properly checked
  // here, we just assume that setOptions is smart enough to not waste a
  // lot of time updating values that didn't change)

  (0,react.useMemo)(function () {
    polyline.setOptions(polylineOptions);
  }, [polyline, polylineOptions]);
  var map = (_useContext = (0,react.useContext)(index_modern/* GoogleMapsContext */._Z)) === null || _useContext === void 0 ? void 0 : _useContext.map; // update the path with the encodedPath

  (0,react.useMemo)(function () {
    if (!encodedPath || !geometryLibrary) return;
    var path = geometryLibrary.encoding.decodePath(encodedPath);
    polyline.setPath(path);
  }, [polyline, encodedPath, geometryLibrary]); // create polyline instance and add to the map once the map is available

  (0,react.useEffect)(function () {
    if (!map) {
      if (map === undefined) console.error("<Polyline> has to be inside a Map component.");
      return;
    }

    polyline.setMap(map);
    return function () {
      polyline.setMap(null);
    };
  }, [map]); // attach and re-attach event-handlers when any of the properties change

  (0,react.useEffect)(function () {
    if (!polyline) return; // Add event listeners

    var gme = google.maps.event;
    [["click", "onClick"], ["drag", "onDrag"], ["dragstart", "onDragStart"], ["dragend", "onDragEnd"], ["mouseover", "onMouseOver"], ["mouseout", "onMouseOut"]].forEach(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
          eventName = _ref2[0],
          eventCallback = _ref2[1];

      gme.addListener(polyline, eventName, function (e) {
        var callback = callbacks.current[eventCallback];
        if (callback) callback(e);
      });
    });
    return function () {
      gme.clearInstanceListeners(polyline);
    };
  }, [polyline]);
  return polyline;
}
/**
 * Component to render a polyline on a map
 */


var Polyline = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var polyline = usePolyline(props);
  (0,react.useImperativeHandle)(ref, function () {
    return polyline;
  }, []);
  return null;
});
Polyline.displayName = "Polyline";
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteListMapPolyline.tsx




var CruiseRouteListMapPolyline = function CruiseRouteListMapPolyline(props) {
  var coordinates = props.coordinates;

  var _useState = (0,react.useState)(),
      encodedPath = _useState[0],
      setEncodedPath = _useState[1];

  var geometryLib = (0,index_modern/* useMapsLibrary */.kY)("geometry");
  (0,react.useEffect)(function () {
    if (!geometryLib || !coordinates) {
      return;
    }

    var path = geometryLib.encoding.encodePath(coordinates);
    setEncodedPath(path);
  }, [geometryLib]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Polyline, {
    strokeWeight: 2,
    encodedPath: encodedPath
  });
};
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteListDynamicMap.tsx










var CruiseRouteListDynamicMap = function CruiseRouteListDynamicMap(props) {
  var cruiseRoutes = props.cruiseRoutes,
      heightStyle = props.heightStyle;

  var getMiddlePosition = function getMiddlePosition(prev, next) {
    if (prev && next) {
      var lat1 = Number(prev.lat);
      var lon1_original = Number(prev.lng);
      var lat2 = Number(next.lat);
      var lon2_original = Number(next.lng); // 経度を比較し、必要なら一方を±360度シフト

      var lon1 = lon1_original;
      var lon2 = lon2_original;

      if (Math.abs(lon1 - lon2) > 180) {
        if (lon1 > lon2) {
          lon2 += 360;
        } else {
          lon1 += 360;
        }
      } // 緯度は通常通り平均


      var latitude = (lat1 + lat2) / 2; // 経度は補正後の値で平均し、-180～180度範囲内に正規化

      var midpointLongitude = (lon1 + lon2) / 2;

      if (midpointLongitude > 180) {
        midpointLongitude -= 360;
      } else if (midpointLongitude <= -180) {
        midpointLongitude += 360;
      }

      var longitude = midpointLongitude;
      return {
        lat: latitude,
        lng: longitude
      };
    }

    return null;
  };

  var findNearestPosition = function findNearestPosition(routes, currentIndex) {
    var prev = routes.slice(0, currentIndex).reverse().find(function (route) {
      var _route$port, _route$port2;

      return (route === null || route === void 0 ? void 0 : (_route$port = route.port) === null || _route$port === void 0 ? void 0 : _route$port.latitude) && (route === null || route === void 0 ? void 0 : (_route$port2 = route.port) === null || _route$port2 === void 0 ? void 0 : _route$port2.longitude);
    });
    var next = routes.slice(currentIndex + 1).find(function (route) {
      var _route$port3, _route$port4;

      return (route === null || route === void 0 ? void 0 : (_route$port3 = route.port) === null || _route$port3 === void 0 ? void 0 : _route$port3.latitude) && (route === null || route === void 0 ? void 0 : (_route$port4 = route.port) === null || _route$port4 === void 0 ? void 0 : _route$port4.longitude);
    });
    return getMiddlePosition(prev ? {
      lat: Number(prev.port.latitude),
      lng: Number(prev.port.longitude)
    } : null, next ? {
      lat: Number(next.port.latitude),
      lng: Number(next.port.longitude)
    } : null);
  };

  var markerData = function () {
    var positionCountMap = {};
    return cruiseRoutes.map(function (cruiseRoute, index) {
      var position = null;
      var isInvalid = cruiseRoute.routeType === "sailing" || !cruiseRoute.port || !cruiseRoute.port.latitude || !cruiseRoute.port.longitude;

      if (!isInvalid) {
        position = {
          lat: Number(cruiseRoute.port.latitude),
          lng: Number(cruiseRoute.port.longitude)
        };
      } else {
        position = findNearestPosition(cruiseRoutes, index);
      }

      var positionKey = position ? "".concat(position.lat, ",").concat(position.lng) : null;
      var duplicateCount = positionKey ? positionCountMap[positionKey] || 0 : 0;
      if (positionKey) positionCountMap[positionKey] = duplicateCount + 1;
      return {
        day: cruiseRoute.day,
        title: cruiseRoute.title,
        position: position,
        duplicateCount: duplicateCount
      };
    });
  }();

  var coordinates = markerData.map(function (data) {
    return data.position;
  }); // 平均経度を0度にシフトする関数

  var shiftLongitude = function shiftLongitude(lon, center) {
    var shifted = lon - center; // [-180, 180]に収まるよう正規化

    shifted = (shifted + 180) % 360 - 180;
    return shifted;
  };

  var calculateZoom = function calculateZoom(locations) {
    var latitudes = locations.map(function (loc) {
      return loc.lat;
    });
    var longitudes = locations.map(function (loc) {
      return loc.lng;
    }); // 経度の平均値を求める

    var avgLon = longitudes.reduce(function (a, b) {
      return a + b;
    }, 0) / longitudes.length;
    var shiftedLongitudes = longitudes.map(function (lon) {
      return shiftLongitude(lon, avgLon);
    }); // シフト後の経度の最小・最大を取得

    var maxLon = Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(shiftedLongitudes));
    var minLon = Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(shiftedLongitudes)); // 緯度はそのまま最小・最大を取得

    var maxLat = Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(latitudes));
    var minLat = Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(latitudes));
    var latDiff = maxLat - minLat;
    var lonDiff = maxLon - minLon; // ここでは既に短い弧で計算される
    // 縦方向が小さいため、latitude差は2倍して判定

    var maxDiff = Math.max(latDiff * 2, lonDiff);
    if (maxDiff > 200) return 1; // 世界一周クルーズ（超広域）

    if (maxDiff > 100) return 2; // 世界一周クルーズ（超広域）

    if (maxDiff > 40) return 3; // 地中海クルーズ（広域）

    if (maxDiff > 15) return 4; // 地中海クルーズ（広域）

    if (maxDiff > 7) return 5; // 地域周遊（中広域）

    if (maxDiff > 4) return 6; // 地域周遊（中広域）

    if (maxDiff > 2) return 7; // 短距離クルーズ（狭域）

    return 8; // 短距離クルーズ（狭域）
  };

  function calculateCenter(coordinates) {
    // 度からラジアンへの変換関数
    var toRad = function toRad(deg) {
      return deg * Math.PI / 180;
    };

    var toDeg = function toDeg(rad) {
      return rad * 180 / Math.PI;
    };

    var x = 0;
    var y = 0;
    var z = 0; // 緯度経度を3Dベクトルに変換して加算

    coordinates.forEach(function (coord) {
      var lat = toRad(coord.lat);
      var lon = toRad(coord.lng);
      x += Math.cos(lat) * Math.cos(lon);
      y += Math.cos(lat) * Math.sin(lon);
      z += Math.sin(lat);
    });
    var total = coordinates.length;
    x /= total;
    y /= total;
    z /= total; // 平均ベクトルから「中心」の緯度経度に戻す

    var hyp = Math.sqrt(x * x + y * y);
    var centerLat = Math.atan2(z, hyp);
    var centerLon = Math.atan2(y, x);
    return {
      lat: toDeg(centerLat),
      lng: toDeg(centerLon)
    };
  }

  var zoom = calculateZoom(coordinates);
  var center = calculateCenter(coordinates);
  var filteredMarkerData = markerData.filter(function (data) {
    return data.position !== null;
  });
  var blockStyles = blockStyle;

  if (heightStyle) {
    blockStyles = /*#__PURE__*/(0,emotion_react_browser_esm.css)(blockStyles, ";height:", heightStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_modern/* APIProvider */.un, {
    apiKey: Constants/* GOOGLE_API_KEY */.JO,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      css: blockStyles,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_modern/* Map */.D5, {
        mapTypeControl: false,
        streetViewControl: false,
        clickableIcons: false,
        defaultCenter: center,
        defaultZoom: zoom,
        mapId: "ca303613a46cfe5a",
        gestureHandling: "greedy" // ヒントの表示無効化
        ,
        children: [filteredMarkerData.map(function (data, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListMarker, {
            index: data.day,
            position: data.position,
            duplicateCount: data.duplicateCount
          }, index);
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListMapPolyline, {
          coordinates: coordinates
        })]
      })
    })
  });
};
var blockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("width:auto;height:18rem;border-radius:", borderStyle/* borderRadius.normal */.E.normal, ";overflow:hidden;position:relative;outline:none;" + ( true ? "" : 0),  true ? "" : 0);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseRouteList.tsx + 1 modules
var CruiseRouteList = __webpack_require__(58451);
// EXTERNAL MODULE: ./main/javascripts/components/cruise/CruiseContentTitle.tsx
var CruiseContentTitle = __webpack_require__(21193);
// EXTERNAL MODULE: ./main/javascripts/constants/GoogleTagManagerEventTypes.ts
var GoogleTagManagerEventTypes = __webpack_require__(12327);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteListModalBlock.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















var CruiseRouteListModalBlock = function CruiseRouteListModalBlock(props) {
  var uniqueId = props.uniqueId,
      cruiseRoutes = props.cruiseRoutes,
      departureDate = props.departureDate,
      cabinCode = props.cabinCode,
      enableDynamicMap = props.enableDynamicMap,
      isEventTracking = props.isEventTracking;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["component"]),
      t = _useTranslation.t;

  var showPagePath = (0,react.useMemo)(function () {
    if (departureDate) {
      var params = _objectSpread({
        departure_date: departureDate
      }, cabinCode && {
        cabin_code: cabinCode
      });

      var paramsString = (0,lib.stringify)(params);
      return "/cruises/".concat(uniqueId, "?").concat(paramsString);
    }

    return "/cruises/".concat(uniqueId);
  }, [uniqueId, departureDate, cabinCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    css: routesBlockStyle,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseContentTitle/* CruiseContentTitle */.r, {
      children: t("cruise.itinerary")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: innerStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: mapBlockStyle,
        children: enableDynamicMap ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          css: dynamicMapStyle,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListDynamicMap, {
            cruiseRoutes: cruiseRoutes,
            heightStyle: "100%"
          })
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
          href: showPagePath,
          passHref: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
            target: "_blank"
          }, isEventTracking ? {
            "data-event-category": GoogleTagManagerEventTypes/* GoogleTagManagerEventTypes.clickCruiseShow */.T.clickCruiseShow
          } : {}), {}, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListMap/* CruiseRouteListMap */.o, {
              cruiseRoutes: cruiseRoutes
            })
          }))
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteList/* CruiseRouteList */.$, {
          cruiseRoutes: cruiseRoutes
        })
      })]
    })]
  });
};
var routesBlockStyle =  true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0;
var innerStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)((0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:grid;grid-template-columns:minmax(0, 1fr) minmax(0, 1fr);gap:4%;align-items:flex-start;}" + ( true ? "" : 0),  true ? "" : 0);
var mapBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("margin:", spaceStyle/* space.atom2x */.D.atom2x, " 0 ", spaceStyle/* space.atom3x */.D.atom3x, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{position:sticky;top:0;}" + ( true ? "" : 0),  true ? "" : 0);
var dynamicMapStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("height:18rem;", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{height:28rem;max-height:calc(90vh - 10.5rem);}" + ( true ? "" : 0),  true ? "" : 0);
;// CONCATENATED MODULE: ./main/javascripts/components/cruise/CruiseRouteListModalDialog.tsx
function CruiseRouteListModalDialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var CruiseRouteListModalDialog = function CruiseRouteListModalDialog(props) {
  var displayed = props.displayed,
      uniqueId = props.uniqueId,
      cruiseRoutes = props.cruiseRoutes,
      departureDate = props.departureDate,
      cabinCode = props.cabinCode,
      closeHandler = props.closeHandler,
      enableDynamicMap = props.enableDynamicMap,
      isEventTracking = props.isEventTracking;

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(["button", "component"]),
      t = _useTranslation.t;

  if (!uniqueId) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalDialogWithClose/* ModalDialogWithClose */.Tg, {
    displayed: displayed,
    closeHandler: closeHandler,
    maxWidthStyle: "80rem",
    maxHeightStyle: "90%",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
      css: CruiseRouteListModalDialog_innerStyle,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: contentStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CruiseRouteListModalBlock, {
          uniqueId: uniqueId,
          cruiseRoutes: cruiseRoutes,
          departureDate: departureDate,
          cabinCode: cabinCode,
          enableDynamicMap: enableDynamicMap,
          isEventTracking: isEventTracking
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: buttonBlockStyle,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
          onClick: closeHandler,
          styleKey: "buttonSmallSecondary",
          children: t("common.dismiss")
        })
      })]
    })
  });
};
var CruiseRouteListModalDialog_innerStyle =  true ? {
  name: "kdbhus",
  styles: "height:100%;display:flex;flex-direction:column"
} : 0;
var contentStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("flex:1;padding:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom2x */.D.atom2x, ";overflow-y:auto;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{padding:", spaceStyle/* space.atom3x */.D.atom3x, " ", spaceStyle/* space.atom3x */.D.atom3x, ";}" + ( true ? "" : 0),  true ? "" : 0);
var buttonBlockStyle = /*#__PURE__*/(0,emotion_react_browser_esm.css)("padding:", spaceStyle/* space.atom2x */.D.atom2x, " ", spaceStyle/* space.atom2x */.D.atom2x, " 0;border-top:1px solid ", colorStyle/* borderColor.secondaryLightColor */.tv.secondaryLightColor, ";button{width:100%;margin-bottom:", spaceStyle/* space.atom2x */.D.atom2x, ";}", (0,responsiveStyle/* moreThanBreakpoint */.h6)("tablet"), "{display:flex;justify-content:flex-end;padding:", spaceStyle/* space.atom2x */.D.atom2x, ";button{width:calc(50% - ", spaceStyle/* space.atom */.D.atom, ");max-width:20rem;margin-bottom:0;}}" + ( true ? "" : 0),  true ? "" : 0);

/***/ }),

/***/ 575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tg": function() { return /* binding */ ModalDialogWithClose; }
/* harmony export */ });
/* unused harmony exports defaultBlockStyle, transitionBlockStyles, defaultInnerStyle, transitionInnerStyles */
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70917);
/* harmony import */ var react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98885);
/* harmony import */ var _icon_Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65147);
/* harmony import */ var main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(58589);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var enterDuration = 400;
var exitDuration = 400;
var ModalDialogWithClose = function ModalDialogWithClose(props) {
  var _children = props.children,
      displayed = props.displayed,
      closeHandler = props.closeHandler,
      heightStyle = props.heightStyle,
      widthStyle = props.widthStyle,
      maxWidthStyle = props.maxWidthStyle,
      maxHeightStyle = props.maxHeightStyle,
      _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  var exOverlayStyle = styles.exOverlayStyle,
      exInnerStyle = styles.exInnerStyle,
      exInnerContentStyle = styles.exInnerContentStyle,
      exCloseButtonStyle = styles.exCloseButtonStyle,
      exCloseStyle = styles.exCloseStyle;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setIsMounted(true);
  }, []);

  var closeModal = function closeModal(e) {
    if (displayed) {
      closeHandler(e);
    }
  };

  var onClickOverlay = function onClickOverlay(e) {
    if (ref.current && (ref.current === e.target || !ref.current.contains(e.target))) {
      closeModal(e);
    }
  };

  var innerStyles = innerStyle;

  if (heightStyle) {
    innerStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(innerStyles, ";height:", heightStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  if (widthStyle) {
    innerStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(innerStyles, ";width:", widthStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  if (maxWidthStyle) {
    innerStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(innerStyles, ";max-width:", maxWidthStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  if (maxHeightStyle) {
    innerStyles = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)(innerStyles, ";max-height:", maxHeightStyle, ";" + ( true ? "" : 0),  true ? "" : 0);
  }

  return isMounted && /*#__PURE__*/react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal((0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_transition_group_Transition__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
    timeout: {
      enter: enterDuration,
      exit: exitDuration
    },
    "in": displayed,
    unmountOnExit: true,
    nodeRef: ref,
    children: function children(state) {
      return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
        style: _objectSpread(_objectSpread({}, defaultBlockStyle), transitionBlockStyles[state]),
        css: [blockStyle, exOverlayStyle,  true ? "" : 0,  true ? "" : 0],
        onClick: onClickOverlay,
        ref: ref,
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("div", {
          style: _objectSpread(_objectSpread({}, defaultInnerStyle), transitionInnerStyles[state]),
          css: [innerStyles, exInnerStyle,  true ? "" : 0,  true ? "" : 0],
          className: "popupInner",
          children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
            css: [innerContentStyle, exInnerContentStyle,  true ? "" : 0,  true ? "" : 0],
            children: _children
          }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
            onClick: closeModal,
            css: [closeButtonStyle, exCloseButtonStyle,  true ? "" : 0,  true ? "" : 0],
            children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_Icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .J, {
              styleKey: "close",
              styles: [closeButtonIconStyle, exCloseStyle]
            })
          })]
        })
      });
    }
  }), document.getElementById("modal"));
};
var blockStyle =  true ? {
  name: "7neyfv",
  styles: "position:fixed;top:0;left:0;background-color:rgba(10, 10, 10, 0.2);width:100%;height:100%;z-index:1000"
} : 0;
var innerStyle = /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_5__.css)("position:absolute;top:50%;left:50%;display:flex;width:90%;height:100%;max-height:80%;max-width:540px;background:#fff;border-radius:", main_javascripts_styles_base_borderStyle__WEBPACK_IMPORTED_MODULE_4__/* .borderRadius.normal */ .E.normal, ";box-shadow:0 6px 30px rgba(10, 10, 10, 0.1);box-sizing:border-box;will-change:transform;" + ( true ? "" : 0),  true ? "" : 0);
var innerContentStyle =  true ? {
  name: "nnlx11",
  styles: "width:100%;margin-top:3rem;box-sizing:border-box"
} : 0;
var closeButtonStyle =  true ? {
  name: "1490xaa",
  styles: "display:flex;align-items:center;justify-content:center;width:3rem;height:3rem;text-align:center;box-sizing:border-box;font-size:24px;position:absolute;top:0;right:0;cursor:pointer;opacity:0.5;transition:all 0.3s ease;backface-visibility:hidden;z-index:100;&:hover{opacity:1;}"
} : 0;
var closeButtonIconStyle =  true ? {
  name: "1i2fn2n",
  styles: "line-height:3rem"
} : 0;
var defaultBlockStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  opacity: 0
};
var transitionBlockStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    opacity: 0,
    display: "none"
  }
};
var defaultInnerStyle = {
  transition: "all ".concat(enterDuration, "ms ease"),
  transform: "translate(-50%, -50%) scale(0.9)"
};
var transitionInnerStyles = {
  entering: {
    transform: "translate3d(-50%, -50%, 0) scale(0.9)"
  },
  entered: {
    transform: "translate3d(-50%, -50%, 0) scale(1)"
  },
  exiting: {
    transition: "all ".concat(exitDuration, "ms ease")
  },
  exited: {
    transform: "translate3d(-50%, -50%, 0) scale(0.9)",
    display: "none"
  }
};

/***/ })

}]);